import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../lib/utils';
import { Skeleton } from '../ui/skeleton';

export const PopularSidebar = ({ articles = [], title = "Most Popular", loading = false }) => {
  return (
    <aside className="bg-secondary/50 rounded-sm p-6" data-testid="popular-sidebar">
      <h3 className="font-serif text-xl font-bold mb-6 pb-4 border-b border-border">
        {title}
      </h3>
      <div className="space-y-6">
        {loading ? (
          // Loading skeletons
          Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="flex gap-4">
              <Skeleton className="w-8 h-8 flex-shrink-0" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </div>
            </div>
          ))
        ) : articles.length > 0 ? (
          articles.map((article, index) => (
            <Link 
              key={article.id}
              to={`/article/${article.slug}`}
              className="flex gap-4 group"
              data-testid={`popular-article-${index}`}
            >
              <span className="font-serif text-3xl font-bold text-muted-foreground/30 flex-shrink-0">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="flex-1 min-w-0">
                {/* Headline ONLY - no excerpt, author, date, category */}
                <h4 className="font-serif text-base font-semibold leading-tight line-clamp-3 group-hover:text-primary transition-colors">
                  {article.title}
                </h4>
              </div>
            </Link>
          ))
        ) : (
          <p className="text-muted-foreground text-sm">No articles yet</p>
        )}
      </div>
    </aside>
  );
};

export default PopularSidebar;
